/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".table-fixed[_ngcontent-%COMP%]{width:100%;max-height:50vh;overflow-y:auto}.button__white[_ngcontent-%COMP%]{border:1px solid #666}.button__save[_ngcontent-%COMP%]{background-color:#007bff;color:#fff}"];
export { styles as styles };
